import React from "react";
import MuiButton from "@mui/material/Button";
import { Link } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useAdminAuth } from "context/context";

export const Button = ({ children, to, loading, type, role, ...rest }) => {
  const { roles } = useAdminAuth();

  // custom css for button
  const buttonCss1 = {
    border: "1px solid rgba(255, 118, 5, 0.94)",
    color: "rgba(255, 118, 5, 0.94)",
    "&:hover": {
      backgroundColor: "rgba(255, 118, 5, 0.1)", // Light orange background
      borderColor: "rgba(255, 118, 5, 1)", // Darker orange border
      color: "rgba(255, 118, 5, 1)", // Darker orange text
    },
  };

  return (
    <>
      {/* if type is acl then we have to check role based auth then return data */}
      {type === "acl" &&
        (roles.includes(role) ? (
          <>
            {/* If link */}
            {to ? (
              <Link to={to} {...rest}>
                <MuiButton
                  // color="error"
                  sx={buttonCss1}
                  variant="outlined"
                  {...rest}
                >
                  {children}
                </MuiButton>
              </Link>
            ) : loading ? (
              <MuiButton
                // color="error"
                variant="outlined"
                sx={buttonCss1}
                startIcon={<CircularProgress size={20} color="inherit" />}
                {...rest}
              >
                {children}
              </MuiButton>
            ) : (
              <MuiButton
                // color="error"
                variant="outlined"
                sx={buttonCss1}
                {...rest}
              >
                {children}
              </MuiButton>
            )}
          </>
        ) : null)}

      {/* if type is not acl return normal button */}
      {(type !== "acl" || type === "submit") && (
        <>
          {/* If link */}
          {to ? (
            <Link to={to} {...rest}>
              <MuiButton
                // color="error"
                sx={buttonCss1}
                variant="outlined"
                {...rest}
              >
                {children}
              </MuiButton>
            </Link>
          ) : loading ? (
            <MuiButton
              // color="error"
              variant="outlined"
              sx={buttonCss1}
              startIcon={<CircularProgress size={20} color="inherit" />}
              {...rest}
            >
              {children}
            </MuiButton>
          ) : (
            <MuiButton
              // color="error"
              variant="outlined"
              sx={buttonCss1}
              type={type}
              {...rest}
            >
              {children}
            </MuiButton>
          )}
        </>
      )}

      {/* if loading is true */}
      {/* {loading && (
        <MuiButton
          color="error"
          variant="outlined"
          startIcon={<CircularProgress size={20} color="inherit" />}
          {...rest}
        >
          {children}
        </MuiButton>
      )} */}
    </>
  );
};
